import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@iw/environment';

import { UserApi } from './index';
import { GetUserRes, UpdateUserReq, UpdateUserRes } from '../models';

@Injectable()
export class UserApiService implements UserApi {
  readonly #http = inject(HttpClient);
  readonly #apiHost = environment.apiHost;

  getUser(): Observable<GetUserRes> {
    const api = `${this.#apiHost}me`;

    return this.#http.get<GetUserRes>(api);
  }

  updateUser(params: UpdateUserReq): Observable<UpdateUserRes> {
    return this.#http.patch<UpdateUserRes>(`${this.#apiHost}me`, params);
  }
}
